import { Component, Mixins } from 'vue-property-decorator'
import { HelpersMixin } from '@/mixins/helpers.mixin'
import { ModalMixin } from '@/mixins/modal.mixin'
import { PromisesMixin } from '@/mixins/promises.mixin'
import { FileMixin } from '@/mixins/file.mixin'
import { StoreMixin } from '@/mixins/store.mixin'
import { ToastMixin } from '@/mixins/toast.mixin'
import { CommonOperationGuardMixin } from '@/api/operations/mixins/guards/common-operation-guard.mixin'

@Component
export class AppMixins
    extends Mixins(
        HelpersMixin,
        ModalMixin,
        PromisesMixin,
        FileMixin,
        StoreMixin,
        ToastMixin,
        CommonOperationGuardMixin
    ) {}
